import { Add, Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import {
  activateConsultant,
  baseURL,
  deactivateConsultant,
  getToken,
} from '../../../../helpers/api';
import { useFormik } from 'formik';
import { Upload } from 'antd';
import axios from 'axios';

export default function DocumentUploadForConsultant({ open, onClose, consultantUserId }) {
  const [saving, setSaving] = useState(false);
  const [fileList, setFileList] = useState([]);

  const formik = useFormik({
    initialValues: {
      title: '',
      expiryDate: '',
    },
    onSubmit: (values) => handleSubmit(values),
  });

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleSubmit = async (values) => {
    setSaving(true);
    console.log('values', values);
    try {
      if (fileList?.length < 1) {
        openNotification({ type: 'error', message: 'You must select a document to upload' });
        return;
      }

      const file = fileList[0].originFileObj;

      const formData = new FormData();
      formData.append('title', values?.title);
      formData.append('expiryDate', values?.expiryDate);
      formData.append('file', file);

      const res = await axios.post(`${baseURL}/Consultant/AddDocument`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `bearer ${getToken()}`,
        },
      });
      const { data, status } = res?.data?.result;
      if (status?.code === '00') {
        onClose();
        return openNotification({
          type: 'success',
          message: status?.desc,
        });
      } else {
        return openNotification({
          type: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      console.error('Error:', error);
      return openNotification({
        type: 'error',
        message: 'Something went wrong. Please try again',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Upload Document
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent pt={0}>
        <form onSubmit={formik.handleSubmit}>
          <Grid2 container spacing={2}>
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Upload
                listType="picture-card"
                fileList={fileList}
                onChange={handleFileChange}
                beforeUpload={() => false} // Prevent default upload behavior
              >
                {fileList.length < 1 && (
                  <div>
                    <Add />
                    <div style={{}}>Upload Document</div>
                  </div>
                )}
              </Upload>
            </Grid2>
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              <TextField
                fullWidth
                name="title"
                value={formik.values.title}
                label="Title  "
                required
                onChange={formik.handleChange}
              />
            </Grid2>
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              <TextField
                fullWidth
                name="expiryDate"
                value={formik.values.expiryDate}
                type="date"
                label="Expiry Date (optional)"
                onChange={formik.handleChange}
              />
            </Grid2>
            <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
              <br />
              <Box sx={{ display: 'flex' }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={saving}
                  startIcon={saving && <CircularProgress size={20} />}
                  sx={{ textTransform: 'none', borderRadius: 20, ml: 'auto' }}
                >
                  Upload Document
                </Button>
              </Box>
            </Grid2>
          </Grid2>
        </form>
      </DialogContent>
    </Dialog>
  );
}
